var exports = {
  "A": "codeFileContents__2n7WVf",
  "d": "viewRemainderLink__CmAb5q",
};

module.exports = exports;
